/* unplugin-vue-components disabled */import { render } from "./menuSidebar.vue?vue&type=template&id=5e0599f0"
import script from "./menuSidebar.vue?vue&type=script&lang=js"
export * from "./menuSidebar.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\sama_vue_ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__